export default __webpack_public_path__ + "static/sprite-5ff45dea28184f3c2e00929ef2289a34.svg";